import { Modal, Box } from "@mui/material";

export default function SizeSoftXModalPortatil({ open, onClose, children, sx, ...props }) {
    return (
        <Modal open={open} onClose={onClose} closeAfterTransition {...props}>
            <Box sx={{
                position: 'fixed',
                top: '50%',
                left: '50%',
                transform: 'translate(-50%, -50%)',
                width: 'min(92vw, 480px)',
                maxHeight: '90vh',
                bgcolor: 'background.paper',
                boxShadow: 24,
                borderRadius: 2,
                overflow: 'auto',
                p: 3,
                ...sx
            }}>
                {children}
            </Box>
        </Modal>
    );
}
